<template>
  <div
    class="p-8 w-full flex-no-grow"
    :class="{ 'load load--fill': loading }"
  >
    <h1 v-text="'Import History'" />
    <div class="table-responsive">
      <table class="table table-files min-w-table">
        <thead>
          <tr>
            <th v-text="'Filename'" />
            <th v-text="'Total rows'" />
            <th v-text="'Pending Confirmation'" />
            <th v-text="'Importing'" />
            <th v-text="'Imported'" />
            <th v-text="'Warnings'" />
            <th v-text="'Failed'" />
            <th />
          </tr>
        </thead>
        <tbody v-if="hasImportHistory">
          <tr
            is="ImportHistoryRow"
            v-for="upload in uploads"
            :key="upload.uuid"
            :upload="upload"
          />
        </tbody>
        <tbody v-if="!hasImportHistory">
          <tr>
            <td v-text="'No results'" />
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script type="text/babel">
import ImportHistoryRow from './ImportHistoryRow'

export default {
  name: 'ImportHistory',
  components: {
    ImportHistoryRow,
  },
  data() {
    return {
      loading: false,
      response: {
        data: [],
        meta: {},
        _links: {},
      },
    }
  },
  computed: {
    uploads() {
      return this.response.data
    },
    hasImportHistory() {
      return this.uploads.length
    },
  },
  async mounted() {
    await this.$nextTick()

    this.loading = true

    this.fetch()
    this.startPolling()
  },
  methods: {
    startPolling() {
      this.intervalid1 = setInterval(() => {
        this.fetch()
      }, 3000)
    },
    fetch() {
      this.$api.active().get('memberships/imports/?include=memberCSVs')
        .then((response) => {
          this.loading = false
          this.response = response.data
        })
    },
  },
}
</script>
